import { DateTime } from 'luxon';
import { CANADIAN_TIME_ZONES } from '@billing/validation/timezone';
import type { CanadianTimeZone } from '@billing/validation/timezone';

export const getCanadianTimeZoneLabel = (
  timezone: CanadianTimeZone,
  dateTime: DateTime = DateTime.now()
): string => {
  const abbreviation = dateTime.setZone(timezone).offsetNameShort ?? '';
  return abbreviation
    ? `${CANADIAN_TIME_ZONES[timezone]} (${abbreviation})`
    : CANADIAN_TIME_ZONES[timezone];
};
